// Shared humanization for audit-log action codes — used by the SuperAdmin
// Dashboard "Platform Actions" feed and the Audit Logs page so both read the same.

export const ACTION_LABELS = {
  SA_LOGIN:                    'Logged in',
  SA_VIEW_DASHBOARD:           'Viewed dashboard',
  SA_VIEW_CLUB:                'Viewed club',
  SA_VIEW_CLUB_ADMINS:         'Viewed club admins',
  SA_CREATE_CLUB:              'Created club',
  SA_SUSPEND_CLUB:             'Suspended club',
  SA_REACTIVATE_CLUB:          'Reactivated club',
  SA_SET_PRIMARY_ADMIN:        'Set primary admin',
  SA_REACTIVATE_CLUB_ADMIN:    'Reactivated club admin',
  SA_UPDATE_SUBSCRIPTION:      'Updated subscription',
  SA_START_IMPERSONATION:      'Started impersonation',
  SA_END_IMPERSONATION:        'Ended impersonation',
  SA_UPDATE_TEAM_ROLE:         'Updated team role',
  SA_ADD_CLUB_NOTE:            'Added club note',
  SA_DELETE_CLUB_NOTE:         'Deleted club note',
  SA_CLEANUP_STALE_DISCOUNTS:  'Cleaned stale discounts',
  SA_CLUB_INVITE_SENT:         'Sent club invitation',
  SA_CLUB_INVITE_REVOKED:      'Revoked club invitation',
  SA_CLUB_INVITE_RESENT:       'Resent club invitation',
  EXPENSE_EXPORT:              'Exported expenses',
  STUDENT_EXPORT:              'Exported students',
  EXPENSE_SUBMITTED:           'Submitted expense',
  EXPENSE_APPROVED:            'Approved expense',
  EXPENSE_REJECTED:            'Rejected expense',
  export_report:               'Exported report',
  payment_recorded:            'Payment recorded',
  auto_reminder_run:           'Automatic reminders ran',
};

// Humanize any action code: explicit map first, then snake_case → Sentence case.
export function humanizeAction(code) {
  if (ACTION_LABELS[code]) return ACTION_LABELS[code];
  const s = String(code || '').replace(/^SA_/, '').replace(/_/g, ' ').trim().toLowerCase();
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : 'Activity';
}

// Destructive actions get a subtle soft-red tint (suspend / delete / revoke / etc.).
const DESTRUCTIVE_RE = /(suspend|delete|revoke|remove|reject|deactivate|cancel|write[_-]?off)/i;
export function isDestructiveAction(code) {
  return DESTRUCTIVE_RE.test(String(code || ''));
}
